import { Component, Input } from '@angular/core';
import {
  ControlValueAccessor,
  FormGroup,
  NG_VALUE_ACCESSOR,
} from '@angular/forms';

/**
 * Componente de formulario para ingreso de fechas.
 * Implementa la interfaz ControlValueAccessor para su uso en formularios reactivos.
 */
@Component({
    selector: 'am-date-form',
    templateUrl: './am-date-form.component.html',
    styleUrls: ['./am-date-form.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: AmDateFormComponent,
            multi: true,
        },
    ],
    standalone: false
})

export class AmDateFormComponent implements ControlValueAccessor {

  /**
   * Mensaje de error cuando el patrón de validación no coincide.
   */
  @Input() errorPattern = '';

  /**
   * Mensaje de error cuando el campo es requerido.
   */
  @Input() errorRequired = '';

  /**
   * Formulario reactivo que contiene los controles de fecha.
   */
  @Input() formGroup: FormGroup;

  /**
   * Indica si se debe mostrar el icono de eliminación.
   */
  @Input() iconDelete = true;

  /**
   * Etiqueta del campo de fecha.
   */
  @Input() label = '';

  /**
   * Control de texto para la fecha completa.
   */
  @Input() textControlDate;

  /**
   * Nombre del campo del día.
   */
  @Input() nameInputDay = '';

  /**
   * Placeholder del campo del día.
   */
  @Input() placeholderDay = '';

  /**
   * Control de texto para el día.
   */
  @Input() textControlDay;

  /**
   * Nombre del campo del mes.
   */
  @Input() nameInputMonth = '';

  /**
   * Placeholder del campo del mes.
   */
  @Input() placeholderMonth = '';

  /**
   * Control de texto para el mes.
   */
  @Input() textControlMonth;

  /**
   * Nombre del campo del año.
   */
  @Input() nameInputYear = '';

  /**
   * Placeholder del campo del año.
   */
  @Input() placeholderYear = '';

  /**
   * Control de texto para el año.
   */
  @Input() textControlYear;

  /**
   * Indica si el campo debe manejar tipo de fecha nativa.
   */
  @Input() typeDate = false;

  /**
   * Indica si los campos deben ser de solo lectura.
   */
  @Input() readOnly: boolean = false;

  /**
   * Valor de la fecha seleccionada.
   */
  val: string = '';

  constructor() {}
  writeValue(value: any): void {
    this.value = value;
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  setDisabledState?(isDisabled: boolean): void {
    if (isDisabled) {
      this.textControlDay.disable();
    } else {
      this.textControlDay.enable();
    }
  }

  onChange: any = () => {};
  onTouched: any = () => {};

  set value(val){
    this.val = val
    this.onChange(val)
    if(val){
      this.onTouched(val)
    }
  }
  /**
   * Maneja el cambio de los valores de fecha y permite avanzar automáticamente al siguiente campo.
   * @param elementCurrent Elemento actual en el que se escribe.
   * @param elementAfter Elemento siguiente al cual moverse.
   * @param length Longitud máxima esperada del campo actual.
   */
  onChangeDate(elementCurrent = undefined,elementAfter=undefined,length=0){
    if(elementCurrent?.value?.length == length && elementAfter){
      if( elementCurrent?.id == "birthDay" && elementCurrent?.value > 31
      || elementCurrent?.id == "birthMonth" && elementCurrent?.value > 12){
        return
      }else{
        elementAfter.focus();
      }
    }
    const date = `${this.textControlYear.value}-${this.textControlMonth?.value?.toString().padStart(2, "0")}-${this.textControlDay?.value?.toString().padStart(2, "0")}`;
    this.value = date;
  }

}
